var SCM = SCM || {};

(function (ns, $) {

	ns.registerAnswerLinkClick = function () {
		$('.js-answer-link').on('click', function () {
			var $this = $(this);
			$this.next('.js-answer-wrap').toggleClass('hide');
			$this.find('.js-answer-show').toggleClass('hide');
			$this.find('.js-answer-hide').toggleClass('hide');
		});
	};

})(SCM.ChapterAnswerSet = SCM.ChapterAnswerSet || {}, jQuery);